import { PeoplePicker, PersonType } from "@microsoft/mgt-react";

import { useEmployee } from "../../../hook";

interface Props {
  value?: any;
  onChange?: (value: any) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const MicrosoftPeopleSelect = (props: Props) => {
  const { onChange = () => {}, placeholder = "Thủ trưởng CQ/ĐV" } = props;

  const { data: employees } = useEmployee();

  const onApproverPickerChange = (selectedOptions: any) => {
    let alternateApprover;

    if (selectedOptions.target.selectedPeople.length === 0) {
      onChange(undefined);
      return;
    }
    const selectedEmployee = selectedOptions.target.selectedPeople[0];
    const employee = employees.find(
      (e) => e.eMail === selectedEmployee.userPrincipalName
    );
    if (employee) {
      alternateApprover = `${employee.eMail}|${employee.Title}`;
    } else {
      alternateApprover = `${selectedEmployee?.userPrincipalName}|${selectedEmployee?.displayName}`;
    }

    onChange(alternateApprover);
  };

  return (
    <div
      style={{
        border: "0.7px solid #e0dfdf",
        borderRadius: 2,
        padding: "1px 4px",
        position: "relative",
      }}
    >
      <PeoplePicker
        className="people-picker"
        placeholder={placeholder}
        type={PersonType.any}
        selectionChanged={onApproverPickerChange}
        disabled={props.disabled}
      />
      {props.disabled && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "gray",
            opacity: 0.1,
            cursor: "not-allowed",
          }}
        />
      )}
    </div>
  );
};
